import marbellaFerretti70 from "@/assets/marbella-ferretti70.webp";
import marbellaFairline43 from "@/assets/marbella-fairline43.webp";
import marbellaCranchiM44 from "@/assets/marbella-cranchi-m44.webp";
import marbellaAzimut58 from "@/assets/marbella-azimut58.webp";
import marbellaNuvari64 from "@/assets/marbella-nuvari64.webp";
import marbellaSunseeker42 from "@/assets/marbella-sunseeker42.webp";
import marbellaSearay540 from "@/assets/marbella-searay540.webp";
import marbellaPrincess58 from "@/assets/marbella-princess58.webp";
import marbellaSunseeker68 from "@/assets/marbella-sunseeker68.webp";
import marbellaAicon72 from "@/assets/marbella-aicon72.webp";
import marbellaPredator92 from "@/assets/marbella-predator92.webp";
import marbellaMaiora90 from "@/assets/marbella-maiora90.webp";
import marbellaCranchiMed50 from "@/assets/marbella-cranchi-med50.webp";
import marbellaPrestige50s from "@/assets/marbella-prestige50s.webp";
import marbellaPredator55 from "@/assets/marbella-predator55.webp";
import marbellaMangusta80 from "@/assets/marbella-mangusta80.webp";
import marbellaMangusta80Open from "@/assets/marbella-mangusta80-open.webp";
import marbellaAntago90 from "@/assets/marbella-antago90.webp";
import marbellaSessa35 from "@/assets/marbella-sessa35.webp";
import marbellaLagoon38 from "@/assets/marbella-lagoon38.webp";
import marbellaAzimut39 from "@/assets/marbella-azimut39.webp";
import marbellaAstondoa40 from "@/assets/marbella-astondoa40.webp";
import marbellaSay42 from "@/assets/marbella-say42.webp";
import marbellaAnvera48 from "@/assets/marbella-anvera48.webp";
import marbellaSearay290 from "@/assets/marbella-searay290.webp";
import marbellaRinker270 from "@/assets/marbella-rinker270.webp";
import marbellaRodman44 from "@/assets/marbella-rodman44.webp";
import marbellaSearay46 from "@/assets/marbella-searay46.webp";
import marbellaDoqueve46 from "@/assets/marbella-doqueve46.webp";
import marbellaFairline48 from "@/assets/marbella-fairline48.webp";

export interface MarbellaYachtPricing {
  low: string;
  mid: string;
  high: string;
}

export interface MarbellaYacht {
  slug: string;
  name: string;
  boatName: string;
  image: string;
  length: string;
  guests: string;
  cabins: string;
  cruisingSpeed: string;
  crew: string;
  features: string;
  marina: string;
  pricing4h: MarbellaYachtPricing;
  pricing8h: MarbellaYachtPricing;
  priceNote: string;
  includes: string[];
  description: string;
  duration: string;
  category: "superyacht" | "yacht" | "dayboat";
}

export const marbellaYachts: MarbellaYacht[] = [
  // ── Superyachts (70ft+) ──
  {
    slug: "sunseeker-predator-92",
    name: "Sunseeker Predator 92",
    boatName: "Jax",
    image: marbellaPredator92,
    length: "92 ft / 28 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "20 knots",
    crew: "Professional crew",
    features: "Flybridge, jacuzzi, water toys, premium sound system",
    marina: "Puerto Banús",
    pricing4h: { low: "€6.655", mid: "€7.502", high: "€7.502" },
    pricing8h: { low: "€9.980", mid: "€11.250", high: "€11.250" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels"],
    description: "The Sunseeker Predator 92 is one of the most impressive superyachts available for charter in Marbella. With four luxurious cabins, a spacious salon and expansive exterior deck areas, she offers a level of comfort and performance rarely found. Her aggressive yet elegant lines turn heads in every marina, while the generous flybridge provides the perfect setting for entertaining or simply enjoying the Mediterranean sun.",
    duration: "8 hours",
    category: "superyacht",
  },
  {
    slug: "antago-90",
    name: "Antago 90",
    boatName: "Luna",
    image: marbellaAntago90,
    length: "90 ft / 27 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "18 knots",
    crew: "2 crew",
    features: "Spacious flybridge, dining area, swimming platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€5.929", mid: "€5.929", high: "€6.800" },
    pricing8h: { low: "€8.890", mid: "€8.890", high: "€10.200" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Antago 90 combines Italian craftsmanship with generous living spaces, creating an ideal environment for group charters and celebrations. Her flowing interior layout connects seamlessly to the exterior deck, while the flybridge offers panoramic views of the Costa del Sol coastline. A refined choice for those seeking space and style.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "maiora-90",
    name: "Maiora 90 26DP",
    boatName: "Serenity",
    image: marbellaMaiora90,
    length: "90 ft / 27 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "16 knots",
    crew: "3 crew",
    features: "Flybridge, salon, full galley, swimming platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€4.231", mid: "€4.800", high: "€5.200" },
    pricing8h: { low: "€6.350", mid: "€7.200", high: "€7.800" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 3 Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Maiora 90 26DP represents the pinnacle of Italian yachting heritage. With her displacement hull and refined interiors, she glides through the Mediterranean with effortless grace. Four well-appointed cabins provide overnight capability, while the expansive main deck and flybridge offer multiple entertaining areas. Ideal for those who appreciate understated sophistication.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "mangusta-80-hh",
    name: "Mangusta 80 Open – HH",
    boatName: "Happy Hour",
    image: marbellaMangusta80,
    length: "80 ft / 24 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "10 knots",
    crew: "3 crew",
    features: "Jacuzzi, jet ski, wakeboard, electric surfboard, crazy sofa, inflatable pool",
    marina: "Puerto Banús",
    pricing4h: { low: "€4.719", mid: "€4.719", high: "€5.400" },
    pricing8h: { low: "€7.080", mid: "€7.080", high: "€8.100" },
    priceNote: "Prices include 21% VAT. Fuel included for 30/60 miles.",
    includes: ["Captain & 3 Crew", "Drinks & Snacks", "Fuel", "Water Toys", "Jet Ski", "WiFi & Spotify"],
    description: "The Mangusta 80 Open 'Happy Hour' is the ultimate party yacht in Puerto Banús. This floating luxury club combines speed, style and entertainment in one stunning package. Fully loaded with a jacuzzi, jet ski, wakeboard, electric surfboard, crazy sofa and more — she is the perfect vessel for exclusive events, VIP celebrations and unforgettable days on the water. Premium beverages including champagne and spirits are included.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "mangusta-80-open",
    name: "Mangusta 80 Open",
    boatName: "Estrella",
    image: marbellaMangusta80Open,
    length: "80 ft / 24 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "10 knots",
    crew: "3 crew",
    features: "Open deck layout, water toys, premium sound system",
    marina: "Puerto Banús",
    pricing4h: { low: "€4.719", mid: "€4.719", high: "€5.400" },
    pricing8h: { low: "€7.080", mid: "€7.080", high: "€8.100" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 3 Crew", "Insurance", "Drinks & Snacks", "Water Toys"],
    description: "Another exceptional Mangusta 80 in our Marbella fleet, this open-style superyacht delivers the iconic Italian performance and sleek lines the brand is known for. Her low-profile design and powerful engines create an exhilarating cruising experience, while the generous deck space ensures every guest enjoys the best of the Costa del Sol coastline.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "aicon-72",
    name: "Aicon 72 HT",
    boatName: "Vivace",
    image: marbellaAicon72,
    length: "72 ft / 22 m",
    guests: "Up to 10 guests",
    cabins: "3",
    cruisingSpeed: "14 knots",
    crew: "2 crew",
    features: "Hard top, spacious salon, swimming platform, sun deck",
    marina: "Puerto Banús",
    pricing4h: { low: "€2.500", mid: "€2.800", high: "€3.200" },
    pricing8h: { low: "€3.750", mid: "€4.200", high: "€4.800" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Aicon 72 HT brings together Italian design and impressive volume in a single yacht. Her hard-top design provides shade across the main deck while maintaining an open, airy feel. Three comfortable cabins and a spacious salon make her ideal for extended charters, while the swim platform invites guests to enjoy the crystal-clear waters of the Mediterranean.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "ferretti-70-flybridge",
    name: "Ferretti 70 Flybridge",
    boatName: "Kook",
    image: marbellaFerretti70,
    length: "70 ft / 21.4 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "10 knots",
    crew: "2 crew",
    features: "Flybridge, cherry wood interiors, dining for 8, swimming platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€3.700", mid: "€3.700", high: "€4.200" },
    pricing8h: { low: "€5.550", mid: "€5.550", high: "€6.300" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Drinks & Snacks & Fruit", "2 Paddle Boards", "Snorkelling Equipment", "Dinghy"],
    description: "The Ferretti 70 Flybridge is the perfect family yacht. Elegant cherry wood interiors, refined upholstery and large windows bring natural light throughout. The spacious salon with comfortable sofas connects to a separate dining room with seating for eight. On deck, wide rest areas and a solarium on both the bow and flybridge ensure everyone finds their perfect spot. Four en-suite cabins offer overnight comfort for extended charters.",
    duration: "4 hours",
    category: "superyacht",
  },
  {
    slug: "sunseeker-sports-68",
    name: "Sunseeker Sports 68",
    boatName: "Maia Fair",
    image: marbellaSunseeker68,
    length: "68 ft / 21.7 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "24 knots",
    crew: "2 crew",
    features: "Flybridge terrace, jet ski, wakeboard, seabobs, stabilizers",
    marina: "Puerto Banús",
    pricing4h: { low: "€4.538", mid: "€4.538", high: "€5.200" },
    pricing8h: { low: "€6.810", mid: "€6.810", high: "€7.800" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Drinks & Snacks & Fruit", "Jet Ski", "Wakeboard", "2 Seabobs", "2 Paddle Boards", "Towels"],
    description: "The Sunseeker 68 Sports Yacht is a high-performance masterpiece by the renowned British brand. Twin 1270hp engines deliver exhilarating speed, while custom vector fin stabilizers ensure a smooth ride. The spacious salon and private flybridge terrace offer the ultimate charter experience. Fully loaded with water toys including a jet ski, wakeboard, water ski, seabobs and paddle boards.",
    duration: "4 hours",
    category: "superyacht",
  },

  // ── Yachts (40–65ft) ──
  {
    slug: "nuvari-64-flybridge",
    name: "Nuvari 64 Flybridge",
    boatName: "Horizonte",
    image: marbellaNuvari64,
    length: "64 ft / 19.5 m",
    guests: "Up to 10 guests",
    cabins: "3",
    cruisingSpeed: "18 knots",
    crew: "Professional crew",
    features: "Flybridge, modern interior, sun deck, swimming platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€3.200", mid: "€3.600", high: "€4.000" },
    pricing8h: { low: "€4.800", mid: "€5.400", high: "€6.000" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels"],
    description: "The Nuvari 64 Flybridge is a modern and spacious yacht offering generous deck areas and a comfortable interior. Her flybridge provides panoramic views of the coastline, while the well-designed lower deck houses three comfortable cabins. A versatile choice for cruising along the Costa del Sol with family or friends.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "princess-58",
    name: "Princess 58",
    boatName: "Bella",
    image: marbellaPrincess58,
    length: "58 ft / 17.7 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "22 knots",
    crew: "2 crew",
    features: "Flybridge, spacious cockpit, hydraulic platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€2.300", mid: "€2.600", high: "€2.900" },
    pricing8h: { low: "€3.450", mid: "€3.900", high: "€4.350" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Princess 58 is a refined British flybridge yacht that perfectly balances performance and comfort. Her elegant lines and well-appointed interior create a welcoming atmosphere, while the spacious cockpit and flybridge offer ample space for relaxing under the Mediterranean sun. A dependable and stylish choice for day charters from Puerto Banús.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "azimut-58-flybridge",
    name: "Azimut 58 Flybridge",
    boatName: "Dolce Vita",
    image: marbellaAzimut58,
    length: "58 ft / 17.6 m",
    guests: "Up to 10 guests",
    cabins: "3",
    cruisingSpeed: "16 knots",
    crew: "2 crew",
    features: "Flybridge, Italian design, full galley, sun pads",
    marina: "Puerto Banús",
    pricing4h: { low: "€3.327", mid: "€3.327", high: "€3.800" },
    pricing8h: { low: "€4.990", mid: "€4.990", high: "€5.700" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Azimut 58 Flybridge showcases the finest Italian yacht design. Her flowing lines and luxurious interior create a sense of effortless elegance. Three well-appointed cabins provide comfort below deck, while the generous flybridge and cockpit areas are ideal for entertaining. A classic Azimut experience along the Costa del Sol.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "sunseeker-predator-55",
    name: "Sunseeker Predator 55",
    boatName: "Shadow",
    image: marbellaPredator55,
    length: "55 ft / 16.8 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "28 knots",
    crew: "2 crew",
    features: "Sporty design, hard top, powerful engines, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.815", mid: "€2.100", high: "€2.400" },
    pricing8h: { low: "€2.720", mid: "€3.150", high: "€3.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels"],
    description: "The Sunseeker Predator 55 delivers the aggressive styling and thrilling performance the Predator line is famous for. Her muscular hull cuts through the waves with confidence, while the well-appointed interior provides a comfortable retreat. Three cabins and a spacious cockpit make her ideal for guests who appreciate both speed and style.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "sea-ray-sundancer-540",
    name: "Sea Ray Sundancer 540",
    boatName: "Costa",
    image: marbellaSearay540,
    length: "54 ft / 16.5 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "20 knots",
    crew: "Professional crew",
    features: "Hard top, generous cockpit, swim platform, sun pads",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.800", mid: "€2.100", high: "€2.400" },
    pricing8h: { low: "€2.700", mid: "€3.150", high: "€3.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels"],
    description: "The Sea Ray Sundancer 540 is a spacious and comfortable cruiser designed for easy days on the water. Her generous cockpit provides ample seating for socializing, while the hard top offers welcome shade on warm Mediterranean afternoons. Below deck, three cabins ensure plenty of room for longer charters.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "prestige-50s",
    name: "Prestige 50S",
    boatName: "Elegance",
    image: marbellaPrestige50s,
    length: "50 ft / 15.3 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "22 knots",
    crew: "2 crew",
    features: "Sport bridge, modern interior, electric sunroof, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.815", mid: "€2.100", high: "€2.400" },
    pricing8h: { low: "€2.720", mid: "€3.150", high: "€3.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels", "Drinks & Snacks"],
    description: "The Prestige 50S brings French elegance to the Costa del Sol. Her modern interior layout maximizes natural light and space, while the sport bridge provides a second helm position with stunning views. Three well-finished cabins and a bright salon make her an excellent choice for comfortable day charters from Puerto Banús.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "cranchi-mediterranee-50",
    name: "Cranchi Mediterranee 50",
    boatName: "Azzurra",
    image: marbellaCranchiMed50,
    length: "50 ft / 15.2 m",
    guests: "Up to 12 guests",
    cabins: "3",
    cruisingSpeed: "18 knots",
    crew: "2 crew",
    features: "Flybridge, Italian styling, spacious cockpit, sun deck",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.500", mid: "€1.800", high: "€2.100" },
    pricing8h: { low: "€2.250", mid: "€2.700", high: "€3.150" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & 2 Crew", "Insurance", "Towels"],
    description: "The Cranchi Mediterranee 50 is a beautifully designed Italian flybridge yacht offering generous deck space and a refined interior. Her classic Mediterranean lines and comfortable layout make her a popular choice for family charters and group outings along the Costa del Sol.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "anvera-48",
    name: "Anvera 48",
    boatName: "Vento",
    image: marbellaAnvera48,
    length: "48 ft / 14.6 m",
    guests: "Up to 11 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "Skipper",
    features: "Carbon hull, T-top, high performance, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€2.500", mid: "€2.500", high: "€2.800" },
    pricing8h: { low: "€3.750", mid: "€3.750", high: "€4.200" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Anvera 48 is a high-performance Italian day boat with a carbon fibre hull that delivers an exceptional ride. Her striking design and powerful engines make her one of the fastest boats in Puerto Banús. The T-top provides shade while maintaining an open, sporty feel — ideal for those who value speed and style on the water.",
    duration: "8 hours",
    category: "yacht",
  },
  {
    slug: "fairline-targa-48",
    name: "Fairline Targa 48",
    boatName: "Grace",
    image: marbellaFairline48,
    length: "48 ft / 14.6 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "22 knots",
    crew: "Skipper",
    features: "Hard top, spacious cockpit, sun pads, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.290", mid: "€1.470", high: "€1.670" },
    pricing8h: { low: "€1.936", mid: "€2.200", high: "€2.500" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Fairline Targa 48 is a refined British sport cruiser combining elegant lines with robust build quality. Her spacious cockpit and sun pads provide the perfect environment for relaxing, while two comfortable cabins below deck offer privacy and comfort. A dependable and stylish choice for a full day on the water.",
    duration: "8 hours",
    category: "yacht",
  },
  {
    slug: "sea-ray-sundancer-46",
    name: "Sea Ray Sundancer 46",
    boatName: "Sol",
    image: marbellaSearay46,
    length: "46 ft / 14 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "22 knots",
    crew: "Skipper",
    features: "Express cruiser, cockpit lounge, swim platform, cabin",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.775", mid: "€1.775", high: "€2.000" },
    pricing8h: { low: "€2.662", mid: "€2.662", high: "€3.000" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Sea Ray Sundancer 46 is a timeless American express cruiser known for its spacious cockpit and comfortable cabin layout. Smooth handling and generous seating make her an easy-going choice for full-day charters, whether cruising along the coast or anchoring in a quiet cove.",
    duration: "8 hours",
    category: "yacht",
  },
  {
    slug: "doqueve-majestic-46",
    name: "Doqueve Majestic 46",
    boatName: "Cielo",
    image: marbellaDoqueve46,
    length: "46 ft / 14 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "18 knots",
    crew: "Skipper",
    features: "Flybridge, spacious deck, swimming platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.533", mid: "€1.533", high: "€1.735" },
    pricing8h: { low: "€2.299", mid: "€2.299", high: "€2.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Doqueve Majestic 46 is a classic Spanish-built flybridge yacht offering generous space and dependable performance. Her upper deck provides stunning views while cruising along the Costa del Sol, and the well-proportioned interior creates a comfortable environment for longer charters.",
    duration: "8 hours",
    category: "yacht",
  },
  {
    slug: "cranchi-m44-ht",
    name: "Cranchi M44 HT",
    boatName: "Aria",
    image: marbellaCranchiM44,
    length: "44 ft / 13.5 m",
    guests: "Up to 10 guests",
    cabins: "2",
    cruisingSpeed: "24 knots",
    crew: "Skipper",
    features: "Hard top, modern Italian design, sun pads, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.850", mid: "€2.100", high: "€2.400" },
    pricing8h: { low: "€2.775", mid: "€3.150", high: "€3.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Cranchi M44 HT is a contemporary Italian hard-top yacht with striking design and excellent performance. Her modern interior is bathed in natural light, while the generous cockpit and sun pads provide the ideal setting for a relaxed day on the water. Two cabins below deck add comfort for longer charters.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "rodman-flybridge-44",
    name: "Rodman Flybridge 44",
    boatName: "Marea",
    image: marbellaRodman44,
    length: "44 ft / 13.4 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "16 knots",
    crew: "Skipper",
    features: "Flybridge, sturdy build, spacious cockpit",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.250", mid: "€1.400", high: "€1.600" },
    pricing8h: { low: "€1.875", mid: "€2.100", high: "€2.400" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Rodman Flybridge 44 is a robust Spanish-built yacht known for its seaworthiness and practical layout. The flybridge offers a second social area with commanding views, while the spacious cockpit and well-equipped cabins provide comfort throughout the day.",
    duration: "8 hours",
    category: "yacht",
  },
  {
    slug: "fairline-targa-43",
    name: "Fairline Targa 43",
    boatName: "Jade",
    image: marbellaFairline43,
    length: "43 ft / 13.1 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "24 knots",
    crew: "Skipper",
    features: "Hard top, sporty lines, cockpit lounge, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.331", mid: "€1.500", high: "€1.800" },
    pricing8h: { low: "€2.000", mid: "€2.250", high: "€2.700" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Fairline Targa 43 combines British engineering with sporty Mediterranean styling. Her responsive handling and comfortable cockpit make her a joy to cruise, while two well-appointed cabins provide a private retreat. An excellent mid-range option for exploring the coastline from Puerto Banús.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "say-42",
    name: "Say 42",
    boatName: "Flash",
    image: marbellaSay42,
    length: "42 ft / 12.8 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "30 knots",
    crew: "2 crew",
    features: "High performance, minimalist design, T-top, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.099", mid: "€1.300", high: "€1.500" },
    pricing8h: { low: "€1.650", mid: "€1.950", high: "€2.250" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels"],
    description: "The Say 42 is a sleek and modern high-performance day boat that delivers thrilling speed with minimalist elegance. Her clean lines and powerful engines make her stand out in any marina, while the open deck layout ensures every guest enjoys the sun and sea breeze.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "sunseeker-mustique-42",
    name: "Sunseeker Mustique 42",
    boatName: "Azure",
    image: marbellaSunseeker42,
    length: "42 ft / 12.8 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "22 knots",
    crew: "Skipper",
    features: "Classic Sunseeker design, cockpit lounge, sun pads",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.200", mid: "€1.400", high: "€1.600" },
    pricing8h: { low: "€1.800", mid: "€2.100", high: "€2.400" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Sunseeker Mustique 42 carries the unmistakable DNA of the renowned British brand. Her classic lines and well-proportioned cockpit create a comfortable and stylish environment for day charters. Two cabins below deck provide privacy, while the sun pads and swim platform invite you to enjoy the Mediterranean at its finest.",
    duration: "4 hours",
    category: "yacht",
  },
  {
    slug: "astondoa-40",
    name: "Astondoa 40",
    boatName: "Brisa",
    image: marbellaAstondoa40,
    length: "40 ft / 12.2 m",
    guests: "Up to 9 guests",
    cabins: "2",
    cruisingSpeed: "18 knots",
    crew: "Skipper",
    features: "Flybridge, Spanish craftsmanship, cockpit dining",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.412", mid: "€1.412", high: "€1.600" },
    pricing8h: { low: "€2.118", mid: "€2.118", high: "€2.400" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Astondoa 40 is a beautifully crafted Spanish yacht offering a comfortable flybridge and practical layout. Her warm interiors and generous cockpit dining area make her an inviting choice for full-day charters along the Costa del Sol.",
    duration: "8 hours",
    category: "yacht",
  },

  // ── Day Boats (<40ft) ──
  {
    slug: "azimut-39",
    name: "Azimut 39",
    boatName: "Piccola",
    image: marbellaAzimut39,
    length: "39 ft / 11.9 m",
    guests: "Up to 11 guests",
    cabins: "2",
    cruisingSpeed: "20 knots",
    crew: "Skipper",
    features: "Italian design, hard top, cockpit lounge, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.412", mid: "€1.412", high: "€1.600" },
    pricing8h: { low: "€2.118", mid: "€2.118", high: "€2.400" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Azimut 39 brings Italian refinement to a compact and versatile yacht. Her hard top provides shade across the cockpit, while two well-finished cabins below deck offer comfort for extended charters. An excellent value option combining Azimut quality with manageable size.",
    duration: "8 hours",
    category: "dayboat",
  },
  {
    slug: "lagoon-catamaran-38",
    name: "Lagoon Catamaran 38",
    boatName: "Calma",
    image: marbellaLagoon38,
    length: "38 ft / 11.6 m",
    guests: "Up to 12 guests",
    cabins: "4",
    cruisingSpeed: "8 knots",
    crew: "2 crew",
    features: "Catamaran stability, spacious deck, trampolines, covered cockpit",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.290", mid: "€1.470", high: "€1.670" },
    pricing8h: { low: "€1.936", mid: "€2.200", high: "€2.500" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain & Crew", "Insurance", "Towels"],
    description: "The Lagoon Catamaran 38 offers unmatched stability and deck space, making her the most comfortable option for groups and families. Her twin-hull design virtually eliminates rolling, while the spacious trampolines and covered cockpit provide multiple areas to relax. Four cabins make her ideal for overnight adventures.",
    duration: "8 hours",
    category: "dayboat",
  },
  {
    slug: "sessa-oyster-c35",
    name: "Sessa Oyster C35",
    boatName: "Sol y Mar",
    image: marbellaSessa35,
    length: "35 ft / 10.7 m",
    guests: "Up to 10 guests",
    cabins: "1",
    cruisingSpeed: "22 knots",
    crew: "Skipper",
    features: "Sport cruiser, T-top, cockpit lounge, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€1.300", mid: "€1.300", high: "€1.470" },
    pricing8h: { low: "€1.950", mid: "€1.950", high: "€2.200" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Sessa Oyster C35 is a sporty Italian cruiser that punches above her weight. Her agile handling and comfortable cockpit create a fun and engaging day on the water, while the cabin below provides a private retreat. An accessible entry point to luxury yachting in Marbella.",
    duration: "8 hours",
    category: "dayboat",
  },
  {
    slug: "sea-ray-amberjack-290",
    name: "Sea Ray Amberjack 290",
    boatName: "Coral",
    image: marbellaSearay290,
    length: "29 ft / 8.8 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "20 knots",
    crew: "Skipper",
    features: "Compact cruiser, cockpit seating, swim platform, cabin",
    marina: "Puerto Banús",
    pricing4h: { low: "€800", mid: "€935", high: "€1.070" },
    pricing8h: { low: "€1.200", mid: "€1.400", high: "€1.600" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Sea Ray Amberjack 290 is a compact and capable cruiser perfect for intimate groups. Her welcoming cockpit and cabin layout provide comfort on the water, while the swim platform makes it easy to enjoy the warm Mediterranean waters. An ideal choice for a relaxed day along the coast.",
    duration: "8 hours",
    category: "dayboat",
  },
  {
    slug: "rinker-270-fiesta-vee",
    name: "Rinker 270 Fiesta Vee",
    boatName: "Fiesta",
    image: marbellaRinker270,
    length: "27 ft / 8.2 m",
    guests: "Up to 9 guests",
    cabins: "1",
    cruisingSpeed: "20 knots",
    crew: "Skipper",
    features: "Sport cruiser, cockpit seating, cabin, swim platform",
    marina: "Puerto Banús",
    pricing4h: { low: "€887", mid: "€1.000", high: "€1.135" },
    pricing8h: { low: "€1.331", mid: "€1.500", high: "€1.700" },
    priceNote: "Prices include 21% VAT. Fuel is calculated and charged on the day of the charter.",
    includes: ["Captain", "Insurance", "Towels"],
    description: "The Rinker 270 Fiesta Vee is a fun and approachable sport cruiser, ideal for smaller groups looking to enjoy a day on the water from Puerto Banús. Her cosy cabin and welcoming cockpit make her a comfortable option, while the swim platform ensures easy access to the sea.",
    duration: "8 hours",
    category: "dayboat",
  },
];
